/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../../utils/xhr';
import exibirErro from '../../utils/exibir-erro';
import mensagemSucesso from './mensagem-sucesso';
import getElementoPorId from '../../utils/get-elemento-por-id';
import { type FormularioContato } from '../../empresa/types';
import { getDadosFormularioContatos } from './get-formulario';
import { type Contato } from '../../usuario/types';
import proximaEtapa from './proximaEtapa';

const converterFormularioParaContatos = (empresasId: number, form: FormularioContato): Contato => ({
    empresasId,
    id: form.id,
    nome: form.nome,
    ddd: form.telefone ? form.telefone.replace(/\D/g, '').substr(0, 2) : '',
    numero: form.telefone ? form.telefone.replace(/\D/g, '').substr(2) : '',
});
const temContato = (contato: Contato) => (
    !contato.id
    && !contato.ddd
    && !contato.nome
    && !contato.numero
);

const cadastrarOuEditarContato = (
    contato: Contato,
): Contato | AxiosPromise<{id: number} | void> => {
    if (!contato.id) {
        if (temContato(contato)) {
            return contato;
        }
        return xhr.post('/empresa/contatos', contato);
    }

    if (contato.id && !contato.ddd && !contato.numero && !contato.nome) {
        return xhr.delete(`/empresa/contatos/${contato.id}`);
    }

    return xhr.put(`/empresa/contatos/${contato.id}`, contato);
};

const cadastroContatos = (empresasId: number) => {
    const form = getElementoPorId('formulario-contato');
    form.onsubmit = async (e) => {
        e.preventDefault();
        try {
            const dados = getDadosFormularioContatos(form)
                .filter(Boolean)
                .map(dado => converterFormularioParaContatos(empresasId, dado));
            await Promise.all(dados.map(cadastrarOuEditarContato));

            mensagemSucesso('Contatos cadastrados.');
            proximaEtapa('endereco');
        } catch (err) {
            exibirErro(err);
        }
    };
};

export default cadastroContatos;
